var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatchaLatte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 288 288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{stroke:#46680b;stroke-linejoin:round;stroke-width:6px;fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 139.5,
    y1: 189,
    x2: 139.5,
    y2: 108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74a12e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#77a333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#80a940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#8fb357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a4c276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#bfd49f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#e0ead0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 288,
    height: 288
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99,108c.68,4,1.41,8,2.17,12-3.9-2.06-8.68-3.61-13.58-2.82-3.88.63-9.34,3-13.24,10.83-3.59,7.18-3,15.2,1.51,22.58,6.83,11,22.79,20.17,36.66,21.27q2.19,8.72,4.48,17.11h72q4.71-17.28,9-36c3.54-15.55,6.51-30.58,9-45ZM85.22,144.83c-2.59-4.19-2.93-8.07-1-11.87,2.2-4.4,4.42-4.77,5.15-4.89a6.24,6.24,0,0,1,1-.07c3.86,0,8.6,3.35,11,5.43L108,160C98.91,157.68,89.39,151.58,85.22,144.83Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchaLatte);
export default __webpack_public_path__ + "static/media/matcha-latte.4911a8f16fddce69faf06772c7a2cc7e.svg";
export { ForwardRef as ReactComponent };